import React from "react";
import { useTranslation } from "react-i18next";
import { Container, Typography, Box } from "@mui/material";
import { motion } from "framer-motion";


const AboutCompanyPage = () => {
    const { t } = useTranslation();


    return (
        <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
        >
            <Container maxWidth="md" sx={{ py: 5 }}>

                <Typography
                    variant="h4"
                    align="center"
                    gutterBottom
                    sx={{
                        fontWeight: 'bold',
                        display: 'inline-block',
                        pb: 1,
                        mb: 4
                    }}
                >
                    {t("aboutcompany.title")}
                </Typography>


                <Box sx={{ mt: 3 }}>
                    <Typography paragraph>{t("aboutcompany.text1")}</Typography>
                    <Typography paragraph>{t("aboutcompany.text2")}</Typography>
                    <Typography paragraph>{t("aboutcompany.text3")}</Typography>
                    <Typography paragraph>{t("aboutcompany.text4")}</Typography>
                </Box>
            </Container>
        </motion.div>
    );
};

export default AboutCompanyPage;
